module.exports = __webpack_public_path__ + "static/img/amenagement.d6ec123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entreprise/amenagement.jpg
// module id = l98S
// module chunks = 0